import {
    GET_INVOICE_PROVIDER_LOADING,
    GET_INVOICE_PROVIDER_SUCCESS,
    GET_INVOICE_PROVIDER_REJECT,
} from "../../actions/invoiceProvider/getAll";

import {
    GET_ORDERS_TO_INVOICE_LOADING,
    GET_ORDERS_TO_INVOICE_SUCCESS,
    GET_ORDERS_TO_INVOICE_REJECT,
} from "../../actions/invoice/getOrdersToInvoiceAll";

import {
    GET_INVOICE_PROVIDER_ID_LOADING,
    GET_INVOICE_PROVIDER_ID_SUCCESS,
    GET_INVOICE_PROVIDER_ID_REJECT,
} from "../../actions/invoiceProvider/getId";

import {
    POST_INVOICE_PROVIDER_LOADING,
    POST_INVOICE_PROVIDER_SUCCESS,
    POST_INVOICE_PROVIDER_REJECT,
    POST_INVOICE_PROVIDER_RESET,
} from "../../actions/invoiceProvider/post";

import {
    POST_INVOICE_DOCUMENT_PROVIDER_LOADING,
    POST_INVOICE_DOCUMENT_PROVIDER_SUCCESS,
    POST_INVOICE_DOCUMENT_PROVIDER_REJECT,
    POST_INVOICE_DOCUMENT_PROVIDER_RESET,
} from "../../actions/invoiceProvider/postInvoiceDocument";

import {
    POST_UPLOAD_INVOICE_DETAILS_LOADING,
    POST_UPLOAD_INVOICE_DETAILS_SUCCESS,
    POST_UPLOAD_INVOICE_DETAILS_REJECT,
    POST_UPLOAD_INVOICE_DETAILS_RESET,
} from "../../actions/invoice/postUploadInvoiceDetails";

import {
    PUT_INVOICE_PROVIDER_LOADING,
    PUT_INVOICE_PROVIDER_SUCCESS,
    PUT_INVOICE_PROVIDER_REJECT,
    PUT_INVOICE_PROVIDER_RESET,
} from "../../actions/invoiceProvider/put";

import {
    DELETE_INVOICE_LOADING,
    DELETE_INVOICE_SUCCESS,
    DELETE_INVOICE_RESET,
    DELETE_INVOICE_REJECT
} from "../../actions/invoice/delete";

import {
    POST_GENERATE_INVOICE_DOCUMENT_LOADING,
    POST_GENERATE_INVOICE_DOCUMENT_RESET,
    POST_GENERATE_INVOICE_DOCUMENT_SUCCESS,
    POST_GENERATE_INVOICE_DOCUMENT_REJECT
} from "../../actions/invoice/postGenerateInvoiceDoc";

import {
    DELETE_ROUTE_INVOICE_LOADING,
    DELETE_ROUTE_INVOICE_SUCCESS,
    DELETE_ROUTE_INVOICE_RESET,
    DELETE_ROUTE_INVOICE_REJECT
} from "../../actions/invoice/deleteRouteInvoice";

const stateInit = {
    isLoading: false,
    isSuccess: false,
    isReject: false,
    error: {},
    data: [],
    ordersToInvoice: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    detail: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: [],
    },
    post: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    document: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    invoiceDetails: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    put: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    delete: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    documentGenerateInvocie: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    deleteRoute: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    }
}

const invoiceProviderReducer = (state = stateInit, action) => {
    switch (action.type) {
        // ------------- GET ALL --------------------
        case GET_INVOICE_PROVIDER_LOADING: return {
            ...state,
            isLoading: true,
            isSuccess: false,
            isReject: false,
            data: [],
            error: {},
        }
        case GET_INVOICE_PROVIDER_SUCCESS: return {
            ...state,
            isLoading: false,
            isSuccess: true,
            isReject: false,
            error: {},
            ...action.payload,
        }
        case GET_INVOICE_PROVIDER_REJECT: return {
            ...state,
            isLoading: false,
            isSuccess: false,
            isReject: true,
            data: [],
            error: action.payload?.response?.data
        }

        // ------------- GET ORDERS_TO_INVOICE ALL --------------------
        case GET_ORDERS_TO_INVOICE_LOADING: return {
            ...state,
            ordersToInvoice: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: [],
                error: {},
            }
        }
        case GET_ORDERS_TO_INVOICE_SUCCESS: return {
            ...state,
            ordersToInvoice: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case GET_ORDERS_TO_INVOICE_REJECT: return {
            ...state,
            ordersToInvoice: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: [],
                error: action.payload?.response?.data
            }
        }

        // ------------- GET ID ID --------------------
        case GET_INVOICE_PROVIDER_ID_LOADING: return {
            ...state,
            detail: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case GET_INVOICE_PROVIDER_ID_SUCCESS: return {
            ...state,
            detail: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case GET_INVOICE_PROVIDER_ID_REJECT: return {
            ...state,
            detail: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }

        // ------------- POST INVOICE_DOCUMENT --------------------
        case POST_INVOICE_DOCUMENT_PROVIDER_LOADING: return {
            ...state,
            document: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case POST_INVOICE_DOCUMENT_PROVIDER_SUCCESS: return {
            ...state,
            document: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case POST_INVOICE_DOCUMENT_PROVIDER_REJECT: return {
            ...state,
            document: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case POST_INVOICE_DOCUMENT_PROVIDER_RESET: return {
            ...state,
            document: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }

        // ------------- POST UPLOAD_INVOICE_DETAILS --------------------
        case POST_UPLOAD_INVOICE_DETAILS_LOADING: return {
            ...state,
            invoiceDetails: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case POST_UPLOAD_INVOICE_DETAILS_SUCCESS: return {
            ...state,
            invoiceDetails: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case POST_UPLOAD_INVOICE_DETAILS_REJECT: return {
            ...state,
            invoiceDetails: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case POST_UPLOAD_INVOICE_DETAILS_RESET: return {
            ...state,
            invoiceDetails: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }

        // ------------- POST --------------------
        case POST_INVOICE_PROVIDER_LOADING: return {
            ...state,
            post: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case POST_INVOICE_PROVIDER_SUCCESS: return {
            ...state,
            post: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case POST_INVOICE_PROVIDER_REJECT: return {
            ...state,
            post: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case POST_INVOICE_PROVIDER_RESET: return {
            ...state,
            post: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }

        // ------------- PUT --------------------
        case PUT_INVOICE_PROVIDER_LOADING: return {
            ...state,
            put: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case PUT_INVOICE_PROVIDER_SUCCESS: return {
            ...state,
            put: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case PUT_INVOICE_PROVIDER_REJECT: return {
            ...state,
            put: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case PUT_INVOICE_PROVIDER_RESET: return {
            ...state,
            put: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        // ------------- DELETE --------------------
        case DELETE_INVOICE_LOADING: return {
            ...state,
            delete: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case DELETE_INVOICE_SUCCESS: return {
            ...state,
            delete: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case DELETE_INVOICE_REJECT: return {
            ...state,
            delete: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case DELETE_INVOICE_RESET: return {
            ...state,
            delete: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        // ------------- GENERATA INVOICE DOCUMENT --------------------
        case POST_GENERATE_INVOICE_DOCUMENT_LOADING: return {
            ...state,
            documentGenerateInvocie: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case POST_GENERATE_INVOICE_DOCUMENT_SUCCESS: return {
            ...state,
            documentGenerateInvocie: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case POST_GENERATE_INVOICE_DOCUMENT_REJECT: return {
            ...state,
            documentGenerateInvocie: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case POST_GENERATE_INVOICE_DOCUMENT_RESET: return {
            ...state,
            documentGenerateInvocie: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }

        // ------------- DELETE ROUTE--------------------
        case DELETE_ROUTE_INVOICE_LOADING: return {
            ...state,
            deleteRoute: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case DELETE_ROUTE_INVOICE_SUCCESS: return {
            ...state,
            deleteRoute: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case DELETE_ROUTE_INVOICE_REJECT: return {
            ...state,
            deleteRoute: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case DELETE_ROUTE_INVOICE_RESET: return {
            ...state,
            deleteRoute: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }


        default: return state;
    }
}

export default invoiceProviderReducer